import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import dayjs from 'dayjs';

@Injectable()
export class CustomDateFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = 'DD/MM/YYYY';

  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const parts = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value.trim());
    if (parts === null) {
      return null;
    }

    const day = Number(parts[1]);
    const month = Number(parts[2]);
    const year = Number(parts[3]);
    if (year < 1 || month < 1 || month > 12 || day < 1) {
      return null;
    }

    const date = new Date(0);
    date.setFullYear(year, month - 1, day);
    if (date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
    }

    return { year, month, day };
  }
  format(date: NgbDateStruct): string {
    if (!date) return '';
    let mdt = dayjs(`${date.year}/${date.month}/${date.day}`);
    if (!mdt.isValid()) return '';
    return mdt.format(this.DT_FORMAT);
  }

  timeFormat(date: Date, format: string, locale: string): string {
    if (!date) return '';
    const mdt = dayjs(date);
    return mdt.format(format);
  }
}
